import {useContext, useEffect, useState} from "react";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";

const AddonTypeCard = ({data, onSelect, isSelected}) => {
    const finCheckContext = useContext(FinCheckContext);
    const [discountPercent, setDiscountPercent] = useState(0);

    useEffect(() => {
        if (finCheckContext && finCheckContext.process) {

            if (finCheckContext.process?.discount) {
                if(data.type==="userAddon"){
                    setDiscountPercent(finCheckContext.process.discount.props.FinCheck.user_add_on)
                }else {
                    setDiscountPercent(finCheckContext.process.discount.props.FinCheck.post_add_on)
                }
            }
        }
    }, [])
    const Prices = () => {
        const initPrice = data.type === "postAddon" ? finCheckContext.process.prices.main : finCheckContext.process.prices.user_add_on;

        if (discountPercent > 0 && discountPercent < 100) {
            return <div className="w-full font-semibold flex justify-between items-center">
                    <span className="text-red-500 line-through">
                         {formattedPrice.format((initPrice) / 10)}<small className="mr-1">تومان</small>
                    </span>
                <span className="text-green-500">
                        {formattedPrice.format((initPrice - (discountPercent * initPrice / 100)) / 10)}<small
                    className="mr-1">تومان</small>
                    </span>
            </div>
        } else if (discountPercent === 100) {
            return <div className="flex font-semibold justify-between">
                <span className="text-red-500 line-through">
                         {formattedPrice.format((initPrice) / 10)}<small className="mr-1">تومان</small>
                    </span>
                <span className="text-green-500 ">
                    رایگان
                    </span>
            </div>
        } else {
            return <div className="flex font-semibold justify-end">
                 <span className="text-green-500">
                         {formattedPrice.format((initPrice) / 10)}<small className="mr-1">تومان</small>
                    </span>
            </div>
        }
    }
    const Discount = () => {
        if (discountPercent > 0 && discountPercent < 100) {
            return <span
                className="py-2 rounded-full px-5 z-10 bg-green-500  absolute -top-5 text-sm right-1  text-white">{discountPercent}% تخفیف</span>
        } else if (discountPercent === 100) {
            return <span
                className="py-2  rounded-full px-5 z-10 bg-green-500 absolute -top-5 text-sm  right-1  text-white">رایگان</span>
        }
        return null
    }
    const formattedPrice = new Intl.NumberFormat('fa-IR');
    const handleOnClick = () => {
        onSelect(data.type)
    }

    return (
        <div onClick={handleOnClick}
             className={`w-full relative bg-white p-5 rounded-lg  ${isSelected ? 'border-2 border-green-500 shadow-sm' : 'border-2 border-white'}`}>
            {discountPercent > 0 && <Discount/>}
            <h1 className="font-semibold text-lg">{data.title}</h1>
            <p className="mt-2 mb-1 text-sm">{data.description}</p>
            <Prices/>
        </div>
    )
}
export default AddonTypeCard;